import React, { Component } from "react";
import { Row, Col, Container } from 'react-bootstrap'
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import Footer from "../components/footer/Footer";
import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import PreloaderTwo from '../components/preloader/PreloaderTwo';
import Preloader from "../components/preloader/Preloader";
// import MeatrialAssigning_to_Students from "../components/materials_Assigning/materials_Assigning";
import MeatrialAssigning_to_Students from "../components/MaterialBookSending/materials_Assigning/materials_Assigning";
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile
} from "react-device-detect";

const GET_STUDENT_DETAILS = gql`
query($institute_id:Int){
    getNewEducationalStudents(institute_id: $institute_id) {
        roll_no
        student_name
        class_id
        class_name
        exam_id
        exam_name
        branch_id
        branch_name
        section_id
        section_name
        parent_name
        parent_mobile
        parent_password
        student_id
      }
}
`
const FETCH_GLOBALS = gql`
  query($institution_id: Int!) {
    globals(institution_id: $institution_id) {
      b_e_c_s_data {
        section_id
        class_id
        branch_id
        exam_id
      }
      educationalClasses {
        id
        class
      }
      globalPackages {
        id
        package_name
        exams_covered
      }
      globalCategories {
        id
        category_name
        package_id
      }
      classes {
        id
        class
      }
      exams {
        id
        exam
        exam_subjects{
                subject_id
              }
      }
      globalBranches {
        id
        branch_name
      }
      globalSections {
        id
        section_name
        branch_id
        category_id
        package_id
      }
      offlineExamSubjects{
        id
        subject
      }
      offlineFeeTypes{
        id
        fee_type
      }
    }
  }
`;


const GET_MATERIAL_TYPES = gql`
query($id:Int){
    getMaterialTypes(id:$id){
        id
        material_type
        is_grouping
      }
   }
`;



class MeatrialAssigning extends Component {
    menuToggler = () => {
        const toggled = Cookies.get("toggle");
        if (toggled === "wrapper") {
            this.setState({ toggled: "wrapper sidebar-enable" });
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            this.setState({ toggled: "wrapper" });
            Cookies.set("toggle", "wrapper");
        }
    };
    render() {
        if (Cookies.get("token") == undefined) this.props.history.push("/login");
        const globals = this.props.globals;
        const loading1 = globals.loading;
        const error1 = globals.error;

        // if (loading1) return <PreloaderTwo />;

        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }


        const getStudents = this.props.getStudents;
        const loading2 = getStudents.loading;
        const error2 = getStudents.error;


        // if (loading2) return <PreloaderTwo />;


        if (error2 != undefined) {
            alert("Server Error", +error2.message);
            return null;
        }


        const getMaterialTypes = this.props.getMaterialTypes;
        const loading3 = getMaterialTypes.loading;
        const error3 = getMaterialTypes.error;


        // if (loading3) return <PreloaderTwo />;


        if (error3 != undefined) {
            alert("Server Error", +error2.message);
            return null;
        }





        return (

            <div className={Cookies.get("toggle")}>
                <div className="header-area">
                    <NavbarOne onClick={() => this.menuToggler()} />
                </div>
                <div className="main-wrapper">
                    <div id="sidebar" className={isBrowser == true ? "sidebar-menu d-none d-xl-block d-lg-block" : "sidebar-menu d-block d-xl-none d-lg-none"}>
                        <SideNavbar onClick={() => this.menuToggler()} />
                    </div>
                    <div className="student-overlay" onClick={() => this.menuToggler()} />
                    <div className="content-wrapper pt-0" style={{ minHeight: "50vh" }}>
                        <Container fluid>

                            {

                                loading1 || loading2 || loading3 ? (
                                    <Container><Row className="my-3">
                                        <Col>
                                            <div class="spinner-border text-primary text-center loading-img-center"></div>
                                        </Col>
                                    </Row></Container>
                                ) : (

                                    <>
                                        {
                                            (() => {
                                                let globalsData = globals.globals;

                                                if (Cookies.get("userlevel") != "1" && Cookies.get("userlevel") != "2") {
                                                    let globalBranches = [];

                                                    globalsData.globalBranches.map((item) => {
                                                        if (Cookies.get("branch_id") == item.id) {
                                                            globalBranches.push(item)
                                                        }
                                                    });

                                                    globalsData.globalBranches = globalBranches

                                                }
                                                console.log("globalsData", globalsData);

                                                return (
                                                    <>
                                                        <MeatrialAssigning_to_Students
                                                            globals={globalsData}
                                                            getStudents={getStudents.getNewEducationalStudents}
                                                            getMaterialTypes={getMaterialTypes.getMaterialTypes}
                                                        />
                                                    </>
                                                );
                                            })()
                                        }
                                    </>
                                )
                            }
                        </Container>
                    </div>
                    <Footer />
                </div>
            </div>
        );
    }
}



export default withRouter(
    compose(

        graphql(FETCH_GLOBALS,
            {
                options: props => ({
                    variables: {
                        institution_id: parseInt(Cookies.get("institutionid"))

                    }
                }), name: "globals"
            }),
        graphql(GET_STUDENT_DETAILS, {
            options: (props) => ({
                variables: {
                    institute_id: parseInt(Cookies.get("institutionid")),
                },
            }),
            name: "getStudents",
        }),
        graphql(GET_MATERIAL_TYPES, {
            options: (props) => ({
                variables: {
                    id: parseInt(0),
                },
            }),
            name: "getMaterialTypes",
        }),

    )
        (MeatrialAssigning));